import { render, staticRenderFns } from "./ConfCuenta.vue?vue&type=template&id=572e2e32&scoped=true"
import script from "./ConfCuenta.vue?vue&type=script&lang=js"
export * from "./ConfCuenta.vue?vue&type=script&lang=js"
import style0 from "./ConfCuenta.vue?vue&type=style&index=0&id=572e2e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e2e32",
  null
  
)

export default component.exports